export const BASE_URL =
  // "http://192.168.1.33/laravel-knf-camera-and-weather/public/crm/"; // local
  "https://backend.laravel.knf.products.ninositsolution.com/crm/"; // test
// "https://livelara.knfepl.com/public/crm/"; // UAT
// "https://sirenlaravel-phase3.ninositsolution.com/public/crm/"; // phase 3 testing
//"https://testing.knfepl.com/public/crm/"; // phase 3 live

export const URL = {
  //AUTHENTICATION`
  LOGIN: "admin-login",
  LOGOUT: "admin-logout",
  COMPANY_LOGOUT: "subadmin-logout",
  FORGOT_PASSWORD: "admin/forgot-password",
  TOKEN_VERIFY: "admin-token-verify/",
  CHANGE_PASSWORD: "admin-set-password",

  //ADMIN
  ADD_ADMIN: "add-admin",
  VIEW_ADMIN: "view-admin/",
  ADMIN_STATUS: "change-admin-status/",
  UPDATE_ADMIN: "update-admin",
  LIST_ADMIN: "admin-lists",
  DELETE_ADMIN: "delete-admin/",

  //ROLE

  PERMISSIONS_LIST: "admin/role/module-lists",
  PERMISSIONS_LIST_COMPANY: "company/admin/role/module-lists",
  SUBADMIN_PERMISSIONS_LIST: "subadmin/role/module-lists",
  ROLE_LIST: "admin/role/lists",
  ADD_ROLE: "add-role",
  ADD_ROLE_COMPANY: "company/add-role",
  UPDATE_ROLE: "update-role",
  UPDATE_ROLE_COMPANY: "company/update-role",
  DELETE_ROLE: "delete-role/",
  DELETE_ROLE_COMPANY: "company/delete-role/",
  VIEW_ROLE: "view-role/",
  VIEW_ROLE_COMPANY: "company/view-role/",
  ROLE_STATUS: "change-role-status/",
  ROLE_STATUS_COMPANY: "company/change-role-status/",

  // Company
  COMPANY_LIST: "company-list",
  COMPANY_ADD: "add-company",
  COMPANY_EDIT: "update-company/",
  COMPANY_STATUS: "change-company-status/",
  COMPANY_DELETE: "company-delete/",
  COMPANY_ROLE_LIST: "role-list",
  COMPANY_List_VIEW: "company/view/",
  ADMIN_COMPANY_VIEW: "company/",
  GET_CONSOLIDATED_REPORT_ADMIN: "get-consolidated-report",
  GET_USER_REPORT_ADMIN: "get-user-report",

  // company Devices
  COMPANY_DEVICES: "company/devices",
  COMPANY_DEVICES_VIEW: "device/view/",
  COMPANY_DEVICES_EDIT: "device/update/",
  COMPANY_DEVICES_STATUS: "change-companydevice-status/",
  // company Manager
  COMPANY_MANAGER: "company/profile",
  COMPANY_MANAGER_EDIT: "company/profile/update",
  COMPANY_LOCATION: "location-list",
  // Profile subadmin
  SUBADMIN_LIST: "subadmin-lists",
  SUBADMIN_ADD: "add-subadmin",
  SUBADMIN_VIEW: "view-subadmin/",
  SUBADMIN_EDIT: "subadmin/update/",
  SUBADMIN_STATUS: "change-subadmin-status/",
  SUBADMIN_ROLES: "subadmin-role-list",
  SUBADMIN_ROLES_VIEW: "subadmin-view-role/",
  // profile users
  PROFILE_USER_LIST: "users-lists",
  CHECK_MEMBERS: "check-user-email",
  MEMBERS_LIST: "/device/",
  MEMBERS_LIST_ADD: "add-new/user/",

  // USER LIST
  USER_LIST: "user-lists",
  ADD_USER: "add-user",
  UPDATE_USER: "update-user",
  VIEW_USER: "view-user/",
  USER_STATUS: "change-user-status/",

  // DEVICE LIST
  DEVICE_LIST: "device-lists",
  DEVICE_ADD: "add-device",
  DEVICE_VIEW: "view-device/",
  DEVICE_UPDATE: "update-device",
  DEVICE_STATUS: "change-device-status/",
  DEVICE_USER_LIST: "device-user-lists",
  DEVICE_REPORT: "get-device-logs",
  SUBADMIN_DEVICE_REPORT: "subadmin-get-device-logs",
  DEVICE_REPORT_EXPORT: "export-device-logs",
  NOTIFICATION_REPORT: "get-device-notification-logs",
  SUBADMIN_NOTIFICATION_REPORT: "subadmin-get-device-notification-logs",
  NOTIFICATION_REPORT_EXPORT: "export-device-notification-logs",

  //LOCATION
  LOCATION_LIST: "location-lists",
  LOCATION_STATUS: "change-location-status/",

  // MANUAL_TRIGGER
  MANUAL_TRIGGER: "mannualy-publish-mqtt/",
  CALCULATE_DISTANCE: "calculate-distance",

  // LOG FILE
  LOG_FILE: "logs",

  // CAMERA
  SUPER_ADMIN_ROLES: "superadmin/role/lists",
  SUPER_COMPANY_ADMIN_ROLES: "knfrole/company/lists",
  KNF_ROLES_LIST: "admin/knfrole/lists",
  KNF_COMPANY_ROLES_LIST: "company/admin/knfrole/lists",
  ALERT_TYPE_LIST: "alertType-list",
  ALERT_ESCALATIONS_LIST: "alert-escalations-list",
  KNF_ADMIN_ROLE: "knfadmin/role/lists",
  KNF_COMPANY_LIST: "knf-company-list",
  KNF_COMPANY_LOCATION: "location-lists",
  KNF_COMPANY_VIEW: "knfcompany/view/",
  SITE_LISTS: "site-list",
  SITE_ADD: "add-site",
  SITE_VIEW: "site/view/",
  SITE_STATUS: "change-site-status/",
  SITE_UPDATE: "update-site",
  ACTIVE_SITE: "active-site-list",
  ACTIVE_ADMIN_SITE: "admin-active-site-list",
  SITE_ALERT_TYPES_LIST: "site-alert-types-list",
  SITE_ALERT_TYPES_UPDATE: "site-alert-types/update",
  SITE_ALERT_ESCULATION_UPDATE: "site-alert-escalation/update",
  SITE_ALERT_ESCULATION_LIST: "site-alert-escalation-list",
  COMPANY_LIST_ADMIN: "company-list-admin",
  SITE_LIST_ADMIN: "site-list-admin",
  GROUP_ROLE_LIST: "group-role-list",
  GROUP_USER_ADD: "add-groupUser",
  GROUP_USER_LIST: "group-user-list",
  GROUP_USER_UPDATE: "update-group-user/",
  GROUP_USER_STATUS: "change-groupuser-status/",
  GROUP_USER_DELETE: "delete-group-user/",
  DAY_LIST: "/list-day",
  DATE_LIST: "/list-date",
  SPECIAL_DAY_STORE: "special-day-store",
  SPECIAL_DATE_STORE: "special-date-store",
  COMPANY_SITE_USER_LIST: "company-siteuser-list",
  GROUP_USERS: "group-users/",
  SAMPLE_DATE_EXCEL_DOWNLOAD: "special-date/sample-download",
  CAMERA_LISTS: "camera/list",
  SPECIAL_DATE_IMPORT: "special-dates/import",
  EMAIL_CHECK: "email/check",
  COMPANY_ADMIN_LIST: "company/admin/list",
  ADMIN_ADD_COMPANY: "admin-add-company",
  ADMIN_EDIT_COMPANY: "admin-update-company",
  ADMIN_VIEW_COMPANY: "admin-update-company",
  ADMIN_DELETE_COMPANY: "delete-group-user/",
  ADMIN_STATUS_CHANGE: "change-groupuser-status/",
  ADMIN_DAY_LIST: "day-list",
  ADMIN_DATE_LIST: "date-list",
  UPDATE_ALERT_TYPES: "update-alertType",
  ADMIN_ALERT_TYPES: "site-alert-types-admin-list",
  COMPANY_ALERT_TYPES: "company-site-alert-types-admin-list",
  ADMIN_NOTIFICATION: "admin/notification",
  ADMIN_NOTIFICATION_VIEW: "admin/notification/view/",
  USER_NOTIFICATION: "user/notification",
  USER_NOTIFICATION_VIEW: "user/notification/view/",
  ALERT_TYPES_ALL: "alert/type/list",
  CAMERA_ALERT_LISTS: "camera/alert/list",
  ALERT_TYPES_ALL_ADMIN: "admin/alert/type/list",
  CAMERA_ALERT_LISTS_ADMIN: "admin/camera/alert/list",
  CAMERA_LISTS_ADMIN: "admin/camera/list",
  NOTIFICATION_STATUS_UPDATE: "notification/status/update",
  GROUP_USERS_ACTIVE_LIST: "assigned-users",
  ASSIGNED_USER_STATUS_UPDATE: "assigned-user/status/update",
  ADMIN_NOTIFICATION_COUNT: "get-admin-notification-count",
  USER_NOTIFICATION_COUNT: "get-user-notification-count",
  ADMIN_DASHBOARD: "get-admin-dashboard",
  USER_DASHBOARD: "get-user-dashboard",
  SITE_CAMERA_ALERT_ADD: "site-camera/alerts",
  SITE_CAMERA_ALERT_LIST: "list-camera/alerts",
  SITE_CAMERA_ALERT_STATUS: "update-camera/status",
  SITE_CAMERA_ALERT_UPDATE: "update-camera/alerts",
};
